import { all, takeEvery, put, fork } from 'redux-saga/effects';
import SuperFetch from '@iso/lib/helpers/superFetch';
import actions from './actions';

function* getCompanyStatusReport() {
  yield takeEvery(actions.GET_COMPANY_STATUS_REPORT, function* ({ payload }) {
    try {
      const { startDate, endDate } = payload || {};
      const response = yield SuperFetch.get('/auth/report/company/status', { startDate, endDate });
      yield put(actions.setCompanyStatusReport(response.data));
    } catch (error) {
      yield put(actions.setReportError(error.message));
    }
  });
}

function* getCompanyAgentReport() {
  yield takeEvery(actions.GET_COMPANY_AGENT_REPORT, function* () {
    try {
      const response = yield SuperFetch.get('/auth/report/company/agent');
      yield put(actions.setCompanyAgentReport(response.data));
    } catch (error) {
      yield put(actions.setReportError(error.message));
    }
  });
}

function* getCompanyTimeReport() {
  yield takeEvery(actions.GET_COMPANY_TIME_REPORT, function* ({ payload }) {
    try {
      const { startDate, endDate } = payload;
      const response = yield SuperFetch.get('/auth/report/company/time', { startDate, endDate });
      yield put(actions.setCompanyTimeReport(response.data));
    } catch (error) {
      yield put(actions.setReportError(error.message));
    }
  });
}

function* getCompanyContactReport() {
  yield takeEvery(actions.GET_COMPANY_CONTACT_REPORT, function* () {
    try {
      const response = yield SuperFetch.get('/auth/report/company/contact');
      yield put(actions.setCompanyContactReport(response.data));
    } catch (error) {
      yield put(actions.setReportError(error.message));
    }
  });
}

function* getCompanyContractReport() {
  yield takeEvery(actions.GET_COMPANY_CONTRACT_REPORT, function* () {
    try {
      const response = yield SuperFetch.get('/auth/report/company/contract');
      yield put(actions.setCompanyContractReport(response.data));
    } catch (error) {
      yield put(actions.setReportError(error.message));
    }
  });
}

function* getOverviewReport() {
  yield takeEvery(actions.GET_OVERVIEW_REPORT, function* () {
    try {
      const response = yield SuperFetch.get('/auth/report/overview');
      yield put(actions.setOverviewReport(response.data));
    } catch (error) {
      yield put(actions.setReportError(error.message));
    }
  });
}

function* getTicketStatusReport() {
  yield takeEvery(actions.GET_TICKET_STATUS_REPORT, function* () {
    try {
      const response = yield SuperFetch.get('/auth/report/ticket/status');
      yield put(actions.setTicketStatusReport(response.data));
    } catch (error) {
      yield put(actions.setReportError(error.message));
    }
  });
}

function* getTicketTagReport() {
  yield takeEvery(actions.GET_TICKET_TAG_REPORT, function* () {
    try {
      const response = yield SuperFetch.get('/auth/report/ticket/tag');
      yield put(actions.setTicketTagReport(response.data));
    } catch (error) {
      yield put(actions.setReportError(error.message));
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(getCompanyStatusReport),
    fork(getCompanyAgentReport),
    fork(getCompanyTimeReport),
    fork(getCompanyContactReport),
    fork(getCompanyContractReport),
    fork(getOverviewReport),
    fork(getTicketStatusReport),
    fork(getTicketTagReport)
  ]);
} 